import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { Input } from 'reactstrap';
import tableSort from '../../../../_components/common/Sort';
import { superAdminAction } from '../../../../_actions';
import AccessData from '../../../../_components/common/AccessData';

class ManageBatches extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: null,
            modal: false,
            dropdownOrgId: 'null',
            show: 'null',
            removeFromOrgModal: false,
            addToOrgModal: false,
            sortType: false,
            checkBoxData: [],
            buttonData: [],
            updateModalState: false,
            updateMessage: null,
            analyticsOrganisationBatches: '',
            navData: [],

        }
    }

    componentDidMount() {
        const orgId = +this.props.match.params.id;
        this.setState({
            orgId: +this.props.match.params.id
        })

        this.props.dispatch(superAdminAction.getAnalyticsOrgBatchesHandler(orgId, () => {
            this.props.dispatch(superAdminAction.getAnalyticsActiveBatchesHandler(orgId, () => { }))
        }))

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})


        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Add to Org ',
                    toggler: this.toggleAddtoOrgModal.bind(this),
                    togglerModal: this.state.addToOrgModal,
                    icon: 'fa fa-plus',
                    disabled: 'disabled',
                    title: 'Add to Org '
                },
                {
                    id: 2,
                    name: 'Remove from Org ',
                    toggler: this.toggleremoveFromOrgModal.bind(this),
                    togglerModal: this.state.removeFromOrgModal,
                    icon: 'fa fa-minus',
                    disabled: 'disabled',
                    title: 'Remove from Org '
                },

            ]
        })

    }

    componentDidUpdate(prevProps, prevState) {
        
        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }

        if (prevProps.getAnalyticsActiveBatchesResponse !== this.props.getAnalyticsActiveBatchesResponse) {
            let formatedData = [];
            (this.props.getAnalyticsActiveBatchesResponse !== '' && this.props.getAnalyticsOrgBatchesResponse !== '' && this.props.getAnalyticsOrgBatchesResponse !== undefined) &&
                this.getOrgBatchesReformatData(this.props.getAnalyticsOrgBatchesResponse).map(
                    (data, i) => {
                        let count = 0;
                        for (let i = 0; i < this.props.getAnalyticsActiveBatchesResponse.length; i++) {
                            if (this.props.getAnalyticsActiveBatchesResponse[i].active_batches.length > 0) {
                                for (let j = 0; j < this.props.getAnalyticsActiveBatchesResponse[i].active_batches.length; j++) {
                                    if (this.props.getAnalyticsActiveBatchesResponse[i].active_batches[j].assessment_batches_id === data.id) {
                                        count = count + 1;
                                    }
                                }
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...data,
                                'access': ' fa fa-check text-success',
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...data,
                                'access': ' fa fa-times text-danger',
                            })
                        }
                    }
                )
            if (this.props.getAnalyticsActiveBatchesResponse !== '') {
                this.setState({
                    analyticsOrganisationBatches: formatedData
                })
            }

        }

    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.analyticsOrganisationBatches
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ analyticsOrganisationBatches: arrayCopy });
    }

    toggleEntireOrgModal(showModal) {
        this.setState({
            addToOrgModal: showModal,
            removeFromOrgModal: showModal
        })
    }

    toggleAddtoOrgModal(showModal) {
        this.setState({
            addToOrgModal: showModal
        })
    }

    toggleremoveFromOrgModal(showModal) {
        this.setState({
            removeFromOrgModal: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }



    // this method is used to fetch the selected batch id's which has to be removed and send to service
    onClickRemoveFromOrg(type) {
        if (type === 'Remove') {
            const { checkBoxData } = this.state;
            const { getAnalyticsActiveBatchesResponse } = this.props;
            const activeBatchId = [];

            for (let i = 0; i < checkBoxData.length; i++) {

                if (checkBoxData[i].access === ' fa fa-check text-success') {
                    for (let j = 0; j < getAnalyticsActiveBatchesResponse.length; j++) {
                        if (getAnalyticsActiveBatchesResponse[j].active_batches.length > 0) {
                            for (let k = 0; k < getAnalyticsActiveBatchesResponse[j].active_batches.length; k++) {
                                if (getAnalyticsActiveBatchesResponse[j].active_batches[k].assessment_batches_id === checkBoxData[i].id) {
                                    activeBatchId.push(+getAnalyticsActiveBatchesResponse[j].active_batches[k].id)
                                }
                            }
                        }
                    }
                }
            }
            const fd = {
                'active_batch_id': activeBatchId
            }
            this.props.dispatch(superAdminAction.removeAnalyticsActiveBatchesHandler(fd, +this.props.match.params.id, (data) => {
                this.setState({
                    addToOrgModal: false,
                    dropdownOrgId: 'null',
                    show: 'null',
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message}.</p>
                    </div>`,
                        heading: 'Remove from Organisation',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
            }))
        }

        this.setState({
            removeFromOrgModal: false
        })
    }

    // This method is used to set the checkbox data in state
    getSelectedData(data) {

        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    // this method is used to fetch the html tag data for add (and) remove modal
    getOrgData(checkBoxData) {
        const headings = [{
            'name': 'Batch Name',
            'textCenter':false
        },{
            'name': 'Org Name',
            'textCenter':false
        }, {
            'name': 'Access',
            'textCenter':true

        }]
        const keyNames = [{
            'name': 'batch_name'
        },{
            'name': 'organisation__organisation_name'
        },]
       return AccessData(checkBoxData, headings, keyNames)
    }

    // this method is used to reformat data for analytics org batch response
    getOrgBatchesReformatData = (data) => {
        let returnData = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].organisation_batches.length > 0) {
                for (let j = 0; j < data[i].organisation_batches.length; j++) {

                    returnData.push({
                        ...data[i].organisation_batches[j],
                        'organisation_batch_id': data[i].id,
                        'assessment_organisation_id': data[i].assessment_organisation_id,
                        'rowCheck': true,
                        'access': ' fa fa-times text-danger'
                    })
                }
            }
        }
        return returnData;
    }

    onChangeAssessmentOrganisation = (dropdownOrgId, content, callback) => {
        let returnData = content.filter(
            (data, i) => {
                if (dropdownOrgId !== 'null') {
                    if (data.organisation__organisation_name === dropdownOrgId) {
                        return data
                    }
                }
                if (dropdownOrgId === 'null') {
                    return data
                }
            }
        )
        callback(returnData)
    }
    
    onChangeDropDown = (ev, type) => {
        if (type === 'org') {
            this.setState({
                dropdownOrgId: ev.target.value,
                show: 'null'
            }, () => this.onChangeAssessmentOrganisation(this.state.dropdownOrgId, this.getReformatedTableData(this.props.getAnalyticsOrgBatchesResponse, this.props.getAnalyticsActiveBatchesResponse), (filteredData) => {
                this.getFilteredTableData(this.state.show, filteredData, (callback) => {
                    this.setState({
                        analyticsOrganisationBatches: callback
                    })
                })
            }))
        }
        if (type === 'show') {
            this.setState({
                show: ev.target.value
            }, () => this.getFilteredTableData(this.state.show, this.getReformatedTableData(this.props.getAnalyticsOrgBatchesResponse, this.props.getAnalyticsActiveBatchesResponse), (filteredData) => {
                this.onChangeAssessmentOrganisation(this.state.dropdownOrgId, filteredData, (callback) => {
                    this.setState({
                        analyticsOrganisationBatches:callback
                    })
                })
            }))
        }
    }

    getFilteredTableData(id, tableData, callback) {
        const filteredTableData = [];
        for (let i in tableData) {
            if (id === '1') {
                if (tableData[i].access === " fa fa-check text-success") {
                    filteredTableData.push(tableData[i])
                }
            }
            if (id === '2') {
                if (tableData[i].access === " fa fa-times text-danger") {
                    filteredTableData.push(tableData[i])
                }
            }
            if (id === 'null') {
                filteredTableData.push(tableData[i])
            }
        }
        // this.setState({
        //     analyticsOrganisationBatches: filteredTableData
        // })
        callback(filteredTableData)
    }

    // this method is used to map the reformated org batch data with active batches response
    getReformatedTableData = (getAnalyticsOrgBatchesResponse, getAnalyticsActiveBatchesResponse) => {
        const getOrgBatchesReformatData = this.getOrgBatchesReformatData(getAnalyticsOrgBatchesResponse)
        let formatedData = []
        getOrgBatchesReformatData.map(
            (data, i) => {
                let count = 0;
                for (let i = 0; i < getAnalyticsActiveBatchesResponse.length; i++) {
                    if (getAnalyticsActiveBatchesResponse[i].active_batches.length > 0) {
                        for (let j = 0; j < getAnalyticsActiveBatchesResponse[i].active_batches.length; j++) {
                            if (getAnalyticsActiveBatchesResponse[i].active_batches[j].assessment_batches_id === data.id) {
                                count = count + 1;
                            }
                        }
                    }
                }
                if (count > 0) {
                    formatedData.push({
                        ...data,
                        'access': ' fa fa-check text-success',
                    })
                }
                if (count === 0) {
                    formatedData.push({
                        ...data,
                        'access': ' fa fa-times text-danger',
                    })
                }
            }
        )
        return formatedData
    }

    // this method is used to fetch the selected batch id's which has to be add and send to service
    onClickAddToOrg(type) {
        if (type === 'Add') {
            const { checkBoxData } = this.state;
            const assessment_batches = [];
            for (let i = 0; i < checkBoxData.length; i++) {

                if (checkBoxData[i].access === ' fa fa-times text-danger') {
                    assessment_batches.push(+checkBoxData[i].id)
                }
            }
            const fd = {
                'analytics_organisation': +this.props.match.params.id,
                'assessment_batches': assessment_batches
            }
            this.props.dispatch(superAdminAction.addAnalyticsActiveBatchesHandler(fd, (data) => {
                this.setState({
                    dropdownOrgId: 'null',
                    show: 'null',
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message}.</p>
                    </div>`,
                        heading: 'Add to Organisation',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
            }))
        }

        this.setState({
            addToOrgModal: false
        })
    }

    // This method is used to check whether the selected data has to be add or remove
    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {
            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {
                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    render() {
        const { getAnalyticsActiveBatchesResponse, getAnalyticsOrgBatchesResponse } = this.props;
        const tables = {
            Team: [{
                name: 'Batch Name',
                key: 'batch_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            }, {
                name: 'Organisation Name',
                key: 'organisation__organisation_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            }, {
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
            }
            ]
        }
        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">MANAGE BATCH</h5>
                        <div className="d-flex flex-row flex-wrap justify-content-center">
                            <div className="col-md-6 col-12 px-0 my-2">
                                <div className="d-flex flex-row justify-content-center">
                                    <label className="col- my-1" > Choose Org: &nbsp;
                                    </label>
                                    <Input
                                        value={this.state.dropdownOrgId}
                                        type="select" name="field"
                                        bsSize="sm" className="col-6 border-1"
                                        onChange={(event) => this.onChangeDropDown(event, 'org')}
                                    >
                                        <option className="" value='null' key={0}>All</option>
                                        {
                                            getAnalyticsActiveBatchesResponse !== '' &&
                                            getAnalyticsActiveBatchesResponse.map(
                                                (data, i) => {
                                                    return <option className="" value={data.organsiation_name} key={i}>{data.organsiation_name}</option>
                                                }
                                            )
                                        }

                                    </Input>
                                </div>
                            </div>
                            <div className="col-md-4 col-8 px-0 my-2">
                                <div className="d-flex flex-row justify-content-center">
                                    <label className="col- my-1" > Access: &nbsp;</label>
                                    <Input
                                        value={this.state.show}
                                        type="select" name="field"
                                        bsSize="sm" className="col-8 border-1"
                                        onChange={(event) => this.onChangeDropDown(event, 'show')}
                                    >
                                        <option className="" value='null' key={0}>All</option>;
                                        <option className="" value={1} key={1}>Allow Access</option>
                                        <option className="" value={2} key={2}>Deny Access</option>
                                    </Input>
                                </div>
                            </div>
                        </div>
                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            (getAnalyticsActiveBatchesResponse !== '' && getAnalyticsOrgBatchesResponse !== '' && getAnalyticsOrgBatchesResponse !== undefined) &&
                            <TableNew
                                data={this.state.analyticsOrganisationBatches === '' ? this.getReformatedTableData(getAnalyticsOrgBatchesResponse, getAnalyticsActiveBatchesResponse) : this.state.analyticsOrganisationBatches}
                                columns={tables.Team}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {
                            (getAnalyticsActiveBatchesResponse === '' || getAnalyticsOrgBatchesResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }

                        {
                            this.state.addToOrgModal &&
                            <ModalComponent
                                showModal={this.state.addToOrgModal}
                                heading="Add to Org"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickAddToOrg(type)}
                            />
                        }
                        {
                            this.state.removeFromOrgModal &&
                            <ModalComponent
                                showModal={this.state.removeFromOrgModal}
                                heading="Remove from Org"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlTag={this.getOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickRemoveFromOrg(type)}
                            />
                        }
                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { getAnalyticsOrgBatchesLoading } = state.getAnalyticsOrgBatchesReducer;
    const getAnalyticsOrgBatchesError = state.getAnalyticsOrgBatchesReducer.error;
    const getAnalyticsOrgBatchesResponse = (!getAnalyticsOrgBatchesLoading && !getAnalyticsOrgBatchesError) ? state.getAnalyticsOrgBatchesReducer.data.data.organisation_batch : '';

    const { getAnalyticsActiveBatchesLoading } = state.getAnalyticsActiveBatchesReducer;
    const getAnalyticsActiveBatchesError = state.getAnalyticsActiveBatchesReducer.error;
    const getAnalyticsActiveBatchesResponse = (!getAnalyticsActiveBatchesLoading && !getAnalyticsActiveBatchesError) ? state.getAnalyticsActiveBatchesReducer.data.data.organisation_active_batches : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getAnalyticsOrgBatchesResponse,
        getAnalyticsActiveBatchesResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(ManageBatches);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ManageBatch/index.js